"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateIOSCertVariantCommand = void 0;
const AbstractUpdateVariantCommand_1 = require("./AbstractUpdateVariantCommand");
class UpdateIOSCertVariantCommand extends AbstractUpdateVariantCommand_1.AbstractUpdateVariantCommand {
    constructor(api, appId, variantId) {
        super(api, appId, variantId, 'ios');
        this.withCertificate = (certificate) => {
            this.def.certificate = certificate;
            return this;
        };
        this.withPassphrase = (passphrase) => {
            this.def.passphrase = passphrase;
            return this;
        };
        this.isProduction = () => {
            this.def.production = true;
            return this;
        };
        this.isDevelopment = () => {
            this.def.production = false;
            return this;
        };
    }
}
exports.UpdateIOSCertVariantCommand = UpdateIOSCertVariantCommand;
//# sourceMappingURL=UpdateIOSCertVariantCommand.js.map